import React, { useState } from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Collapse, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ApiIcon from '@mui/icons-material/Api';

const SubmenuContainer = styled(Box)(({ theme }) => ({
  width: 200,
  height: '100vh',
  backgroundColor: '#F7FAFC',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  position: 'fixed',
  left: 80, // Position it right after the main sidebar
  top: 0,
  zIndex: 999,
  borderRight: '1px solid #E2E8F0',
}));

const APISection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: '1px solid #E2E8F0',
  marginBottom: theme.spacing(2),
}));

const APIHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const APITitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: 600,
  color: '#1A202C',
}));

const SubmenuItem = styled(ListItemButton)<{ active?: boolean }>(({ theme, active }) => ({
  padding: theme.spacing(1, 2),
  margin: theme.spacing(0.5, 1),
  borderRadius: 6,
  backgroundColor: active ? '#6B46C1' : 'transparent',
  color: active ? '#FFFFFF' : '#4A5568',
  '&:hover': {
    backgroundColor: active ? '#6B46C1' : '#EDF2F7',
  },
  '& .MuiListItemText-primary': {
    fontSize: '0.9rem',
    fontWeight: active ? 600 : 500,
  },
}));

const APIMonitoringSubmenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [apiOpen, setApiOpen] = useState(true);

  const apiSubmenuItems = [
    { label: 'System Health', path: '/api-monitoring/health', active: location.pathname === '/api-monitoring/health' },
    { label: 'API Metrics', path: '/api-monitoring/metrics', active: location.pathname === '/api-monitoring/metrics' },
    { label: 'Response Times', path: '/api-monitoring/response-times', active: location.pathname === '/api-monitoring/response-times' },
    { label: 'Error Logs', path: '/api-monitoring/errors', active: location.pathname === '/api-monitoring/errors' },
  ];

  return (
    <SubmenuContainer>
      <APISection>
        <APIHeader>
          <ApiIcon sx={{ color: '#6B46C1', fontSize: 24 }} />
          <APITitle>API Monitoring</APITitle>
          <IconButton
            size="small"
            onClick={() => setApiOpen(!apiOpen)}
            sx={{ marginLeft: 'auto', color: '#6B46C1' }}
          >
            {apiOpen ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </APIHeader>
        
        <Collapse in={apiOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {apiSubmenuItems.map((item, index) => (
              <ListItem key={index} disablePadding>
                <SubmenuItem
                  active={item.active}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.label} />
                </SubmenuItem>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </APISection>
    </SubmenuContainer>
  );
};

export default APIMonitoringSubmenu; 